export default {
    listagem: {
        titulo_pagina: 'Configurações para Protocolos genericos',
        novo: 'Criar nova Configuração',
        table: {
            empty: 'Nenhuma Configuração encontrada',
            nome: 'Nome',
            metodo: 'Metodo',
            ordem_url: 'Url para processar Ordem',
            resultado_url: 'Url para processar Resultado',
            busca_resultado_url: 'Endpoint para resultado',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Configuração',
            editar: 'Editar Configuração'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome do Configuração'
            },
            metodo: {
                label: 'Metodo',
                description: 'Metodo executado pelo Protocolo'
            },
            ordem_url: {
                label: 'Url para processar Ordem',
                description: 'Url onde sera feita a extração do pedido e etiqueta'
            },
            resultado_url: {
                label: 'Url para processar Resultado',
                description: 'Url onde sera feita a extração do resultado'
            },
            busca_resultado_url: {
                label: 'Endpoint para busca de resultados',
                description: 'Estara preencido, caso seja diferente da url default da integração'
            },
            tipo_conteudo: {
                label: 'Content-type',
                description: 'Preenchimento para content-type personalizado'
            },
            botao_salvar : 'Salvar Configuração'
        },
        create: {
            success: 'Configuração criada com Sucesso!',
            error: 'Error ao criar Configuração!'
        },
        update: {
            success: 'Configuração editada com Sucesso!',
            error: 'Error ao editar Configuração!'
        }
    }
}
